// extracted by mini-css-extract-plugin
export default {"newMessage":"styles_newMessage__sp0rK","text":"styles_text__nGkoM","icon":"styles_icon__xq892"};